
import '../sass/components/product-list.scss';
import '../sass/components/product-list-filter.scss';
import '../sass/components/pagingation.scss'
import {React, useContext, useEffect, useState, useRef} from "react";
import ProdItem from "./ProdItem";
import {useHistory, useParams} from "react-router-dom";
import Loading from "./Loading";
import {fetchProducts, warmAutocompleteCache} from "../apiRequests/api";
import Selects from "./Selects";
import ReactPaginate from 'react-paginate';
import {useAuth0} from "@auth0/auth0-react";
import {useBasePath} from "../hooks/useBasePath";
import {useRrpCalculatorVisibility} from "../hooks/useRrpCalculatorVisibility";

import {SigninContext} from "../contexts/SigninContext";
import {myProductsLabel} from "../settings";

const SEARCH_DEBOUNCE_MS = 500;

function ProductList (props) {
    const basePath = useBasePath();
    const [bulkUpdateClass, setBulkUpdateClass] = useState('')
    const {userName} = useContext(SigninContext)
    let {pageParam} = useParams()
    let {pageSizeParam} = useParams()
    const [pageSize, setPageSize] = useState(pageSizeParam)
    const [pageRrp, setPageRrp] = useState(null)
    const [rrpCalculatorVisible] = useRrpCalculatorVisibility();
    const [sort, setSort] = useState((new URLSearchParams(window.location.search)).get('sort') ?? '');
    const addToCartRefs = useRef([]);

    const [pageSizeOptions] = useState(
        {
            current: {value: pageSize ? pageSize : 20, label: pageSize ? pageSize : 20},
            options: [
                { value: '10', label: '10' },
                { value: '20', label: '20' },
                { value: '50', label: '50' },
                { value: 'all', label: 'all' },
            ]
        }
    )
    const [sortOptions] = useState({
        current: {value: '', label: 'Default'},
        options: [
            {value: '', label: 'Default'},
            {value: 'description_desc', label: 'A-Z'},
            {value: 'description_asc', label: 'Z-A'},
            {value: 'price_asc', label: 'Price Low to High'},
            {value: 'price_desc', label: 'Price High to Low'},
        ]
    });
    const [allProducts, setAllProducts] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [totalQtyProducts, setTotalQtyProducts] = useState()

    const [description, setDescription] = useState('')
    const [titleInputValue, setTitleInputValue] = useState('')
    const searchDebounceRef = useRef(null)
    const previousDescriptionRef = useRef('')

    // building parameters to call api
    let fetchParameters = {
        "pagedProducts": {
            PageSize: pageSize,
            StartIndex: 1+(pageParam*pageSizeParam)-pageSizeParam
         },
        "sort": sort,
        "basePath": basePath,
        "CustomerAccount" : userName,
        "productsSearchParameters": {description}
    }
    if (props.fetchParams){
        fetchParameters = Object.assign(fetchParameters,props.fetchParams)
    }
    let history = useHistory()
    const handlePageClick = (paginationData) => {
        window.scrollTo({top: 0, behavior: "smooth"});
        pageParam = +paginationData.selected+1
        let url = `${basePath}/${pageParam}/${pageSizeParam?pageSizeParam:20}`;
        if (sort !== '') {
            url += '?sort=' + sort;
        }
        history.push(url);
    }

    const {getIdTokenClaims} = useAuth0()

    async function LoadAllProducts () {
        setIsLoading(true)
          if (pageSize != pageSizeParam || description !== previousDescriptionRef.current) {
            pageParam = 1
        }
        previousDescriptionRef.current = description
        pageSizeParam = pageSize
        let url = `${basePath}/${pageParam}/${pageSizeParam}`;
        if (sort !== '') {
            url += '?sort=' + sort;
            fetchParameters.sort = sort;
        }
        history.push(url);
        const token = await getIdTokenClaims()
        if (pageSizeParam === 'all') {
            fetchParameters.pagedProducts = {}
        }
        if (token){
            const data = await fetchProducts(fetchParameters, token.__raw)
            if(data.error){
                setAllProducts(data)
            } else {
                setAllProducts(data.mainResult)
                setTotalQtyProducts(data.TotalRowCount)
            }

        } else {
            alert('Failed to connect Auth0!')
            window.location.href = '/'
        }
        setIsLoading(false)
    }
    function bulkAddHandler () {
        addToCartRefs.current.forEach(addToCartFn => {
            if (addToCartFn) {
                addToCartFn();
            }
        })
        setBulkUpdateClass('refreshed')
        setTimeout(function(){ setBulkUpdateClass('') }, 500);
    }

    // Automatically search when user is still typing, debounced.
    function handleTitleInputChange(value) {
        setTitleInputValue(value)
        clearTimeout(searchDebounceRef.current)
        searchDebounceRef.current = setTimeout(() => {
            setDescription(value.trim())
        }, SEARCH_DEBOUNCE_MS)
    }

    // Enter flushes the pending debounce immediately, for anyone who prefers
    // to confirm the search rather than wait out the 500ms pause.
    function handleTitleKeyDown(event) {
        if (event.key === 'Enter') {
            clearTimeout(searchDebounceRef.current)
            setDescription(titleInputValue.trim())
        }
    }

    function handleRrpChange(e) {
      let rrp_input = document.querySelector('.product-list-top__rrp_calculator [type="number"]');
      let number = parseFloat(rrp_input.value);
      // Little validation
      if (isNaN(number) || number < 0 || number > 100) {
        e.preventDefault();
        e.stopPropagation();
      }
      else {
        setPageRrp(number);
      }
    }


    useEffect(  () => {
        LoadAllProducts()
    },[userName,pageSize,pageParam,sort,props.fetchParams,description])

    useEffect(() => {
        if (!userName || props.fetchParams) {
            return
        }
        (async () => {
            const token = await getIdTokenClaims()
            warmAutocompleteCache({basePath, CustomerAccount: userName}, token.__raw)
        })()
    }, [userName]);

    return (
        <div className='product-list-component'>

            {!props.fetchParams &&
              <div className="product-list-search">
                  <input type="text"
                         className="product-list-search-input"
                         placeholder={`Search ${myProductsLabel.toLowerCase()}`}
                         value={titleInputValue}
                         autoComplete="off"
                         onChange={(e) => handleTitleInputChange(e.target.value)}
                         onKeyDown={handleTitleKeyDown}
                  />
              </div>
            }

            <Loading isLoading={isLoading}/>
            {!isLoading && userName &&
              <>
                {process.env.REACT_APP_RRP_CALCULATOR === "1" && rrpCalculatorVisible && <div className="product-list-top__rrp_calculator">
                  <h3 className="calculator-title">Calculate RRP</h3>
                  <div className="calculator-inner">
                    <div className="margin-input-wrapper">
                      <input type="number" placeholder="Enter margin" min="0" max="100"/>
                      <div className="percent-box">%</div>
                    </div>
                    <button onClick={handleRrpChange} className="rrp-calculate-button">Calculate</button>
                  </div>
                </div>}
                 <div
                  className={`product-list-filter ${!allProducts.length && 'hide'}`}>
                    <div className="product-list-filter_paginate">
                        {pageSize !== 'all' && totalQtyProducts > 10 &&
                          <ReactPaginate
                            forcePage={pageParam - 1}
                            pageCount={totalQtyProducts / pageSize}
                            previousLabel={'previous'}
                            previousClassName={'previous'}
                            nextLabel={'next'}
                            nextClassName={'next'}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                          />}
                    </div>
                    {totalQtyProducts > 10 &&
                      <div className="product-list-filter_select">
                          <label>Per page :</label>
                          <Selects options={pageSizeOptions.options}
                                   setPropsValue={setPageSize} value={pageSize}/>
                      </div>
                    }
                    <div className="product-list-filter_select product-list-filter_sort">
                        <label>Sort:</label>
                        <Selects options={sortOptions.options}
                                 setPropsValue={setSort} value={sort}/>
                    </div>
                    <div className="bulk-add">
                        <button onClick={() => bulkAddHandler()}
                                className={`bulk-add-btn ${bulkUpdateClass}`}>Bulk
                            Add<i className="fas fa-icon fa-cart-plus"></i>
                        </button>
                    </div>
                </div>
              </>
            }

            <ul className="product-list">

                {!(allProducts.error) ? (
                  allProducts && allProducts.map((product, index) => {
                      return <li className="product-list-item" key={product.Code}><ProdItem
                          product={product}
                          globalRrpMargin={pageRrp}
                          registerAddToCart={(fn) => addToCartRefs.current[index] = fn}
                        /></li>;
                      })
                    ) : (
                        <div className="error-message">{allProducts.error}</div>
                    )
                    }


            </ul>

            <div
              className={`product-list-filter product-list-filter_bottom ${!allProducts.length && 'hide'}`}>
                <div className='product-list-filter_paginate'>
                    {pageSize !== 'all' && totalQtyProducts > 10 &&
                      <ReactPaginate
                        forcePage={pageParam - 1}
                        pageCount={totalQtyProducts / pageSize}
                        previousLabel={'previous'}
                        previousClassName={'previous'}
                        nextLabel={'next'}
                        nextClassName={'next'}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                      />}
                </div>
                <div className='product-list-filter_select'>
                    <label>Per page:</label>
                    <Selects options={pageSizeOptions.options}
                             setPropsValue={setPageSize} value={pageSize}/>
                </div>
                <div className="product-list-filter_select product-list-filter_sort">
                    <label>Sort:</label>
                    <Selects options={sortOptions.options}
                             setPropsValue={setSort} value={sort}/>
                </div>
                <div className='bulk-add'>
                    <button onClick={() => bulkAddHandler()}
                            className={`${bulkUpdateClass}`}>Bulk Add<i
                      className="fas fa-icon fa-cart-plus"></i></button>
                </div>
            </div>

        </div>
    )
}

export default ProductList